var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobTitleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_8906)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_8906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_654_8906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 22.7498H8.00023C3.38023 22.7498 2.52023 20.5998 2.30023 18.5098L1.55023 10.4998C1.44023 9.44977 1.41023 7.89977 2.45023 6.73977C3.35023 5.73977 4.84023 5.25977 7.00023 5.25977H17.0002C19.1702 5.25977 20.6602 5.74977 21.5502 6.73977C22.5902 7.89977 22.5602 9.44977 22.4502 10.5098L21.7002 18.4998C21.4802 20.5998 20.6202 22.7498 16.0002 22.7498ZM7.00023 6.74977C5.31023 6.74977 4.15023 7.07977 3.56023 7.73977C3.07023 8.27977 2.91023 9.10977 3.04023 10.3498L3.79023 18.3598C3.96023 19.9398 4.39023 21.2498 8.00023 21.2498H16.0002C19.6002 21.2498 20.0402 19.9398 20.2102 18.3498L20.9602 10.3598C21.0902 9.10977 20.9302 8.27977 20.4402 7.73977C19.8502 7.07977 18.6902 6.74977 17.0002 6.74977H7.00023Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.75C15.59 6.75 15.25 6.41 15.25 6V5.2C15.25 3.42 15.25 2.75 12.8 2.75H11.2C8.75 2.75 8.75 3.42 8.75 5.2V6C8.75 6.41 8.41 6.75 8 6.75C7.59 6.75 7.25 6.41 7.25 6V5.2C7.25 3.44 7.25 1.25 11.2 1.25H12.8C16.75 1.25 16.75 3.44 16.75 5.2V6C16.75 6.41 16.41 6.75 16 6.75Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.75C9.25 16.75 9.25 15.05 9.25 14.03V13C9.25 11.59 9.59 11.25 11 11.25H13C14.41 11.25 14.75 11.59 14.75 13V14C14.75 15.04 14.75 16.75 12 16.75ZM10.75 12.75C10.75 12.83 10.75 12.92 10.75 13V14.03C10.75 15.06 10.75 15.25 12 15.25C13.25 15.25 13.25 15.09 13.25 14.02V13C13.25 12.92 13.25 12.83 13.25 12.75C13.17 12.75 13.08 12.75 13 12.75H11C10.92 12.75 10.83 12.75 10.75 12.75Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 14.7702C13.6305 14.7702 13.3005 14.4902 13.2605 14.1102C13.2105 13.7002 13.5005 13.3202 13.9105 13.2702C16.5505 12.9402 19.0805 11.9402 21.2105 10.3902C21.5405 10.1402 22.0105 10.2202 22.2605 10.5602C22.5005 10.8902 22.4305 11.3602 22.0905 11.6102C19.7505 13.3102 16.9905 14.4002 14.0905 14.7702C14.0605 14.7702 14.0305 14.7702 14.0005 14.7702Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 14.7809C9.97072 14.7809 9.94072 14.7809 9.91072 14.7809C7.17072 14.4709 4.50072 13.4709 2.19072 11.8909C1.85072 11.6609 1.76072 11.1909 1.99072 10.8509C2.22072 10.5109 2.69072 10.4209 3.03072 10.6509C5.14072 12.0909 7.57072 13.0009 10.0707 13.2909C10.4807 13.3409 10.7807 13.7109 10.7307 14.1209C10.7007 14.5009 10.3807 14.7809 10.0007 14.7809Z",
    fill: "#FFB600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_8906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitleIcon);
export default __webpack_public_path__ + "static/media/job-title-icon.96bc165e4de150326327f89a62178450.svg";
export { ForwardRef as ReactComponent };